import { Component, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, FormArray } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PageEvent } from '@angular/material/paginator';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { RegistrationService } from 'src/shared/services/registration.service';
import { ResponseService } from 'src/shared/services/response-service.service';
import { SchoolProgramService } from 'src/shared/services/school-program.service';
import { TranslateService } from 'src/shared/services/translate.service';
import Swal from 'sweetalert2';
import { AuthService } from 'src/shared/services/auth.service';

@Component({
  selector: 'app-registration-payment',
  templateUrl: './registration-payment.component.html',
  styleUrl: './registration-payment.component.scss'
})
export class RegistrationPaymentComponent {

  loading: any = {};
  paramForm: FormGroup;
  scoreRange: any;
  participants: any;
  displayedColumns: any;
  subscription: any = {};
  warningText: any;
  columnsToDisplay: string[] = ['select', 'student_name', 'is_paid', 'payment_generated', 'total_fee', 'payment_amount', 'payment_date', 'payment_notes', 'payment_logs', 'action'];
  data: any[] = [];
  dataSource = new MatTableDataSource<any>([]);
  selectedIds: Set<number> = new Set();

  searchText = '';
  filterPaid: boolean | null = null;
  isManualPayment: boolean | null = null;
  filterVaGenerated: boolean | null = null;
  sortDirection: 'asc' | 'desc' | '' = '';
  rejectNote: string = '';

  page = 1;
  pageSize = 10;
  totalItems = 0;

  selectedLogsPaymentId: number | null = null;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('confirmModal') confirmModal: TemplateRef<any>;
  @ViewChild('paymentLogsModal') paymentLogsModal: TemplateRef<any>;

  pendingApprove: boolean = true;
  pendingIds: number[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private spService: SchoolProgramService,
    private translate: TranslateService,
    private registService: RegistrationService,
    private rpService: ResponseService,
    private modalService: NgbModal,
    public auth: AuthService
  ) { }

  ngOnInit(): void {
    this.translate.load('registration', 'extracurricular', 'activity');
    this.initForm();
  }

  initForm() {
    this.paramForm = new FormGroup({
      'academic_year': new FormControl(null),
      'school_location_id': new FormControl(null),
      'school_level_id': new FormControl(null),
      'school_program_id': new FormControl(null),
      'school_program_category_id': new FormControl(null),
      'school_program_activity_id': new FormControl(null),
      'year_level_id': new FormControl(null)
    });
  }

  onChangeAcademicYear(item: any) {
    this.paramForm.controls['academic_year'].markAsTouched();
    this.paramForm.controls['academic_year'].setValue(item ? item.academic_year : null);

    this.paramForm.controls['school_location_id'].setValue(null);
    this.paramForm.controls['school_level_id'].setValue(null);
    this.paramForm.controls['school_program_id'].setValue(null);
    this.paramForm.controls['school_program_category_id'].setValue(null);
    this.paramForm.controls['school_program_activity_id'].setValue(null);
    this.paramForm.controls['year_level_id'].setValue(null);
  }

  onChangeSchoolLevel(item: any) {
    this.paramForm.controls['school_location_id'].markAsTouched();
    this.paramForm.controls['school_location_id'].setValue(item ? item.school_location_id : null);

    this.paramForm.controls['school_level_id'].markAsTouched();
    this.paramForm.controls['school_level_id'].setValue(item ? item.school_level_id : null);

    this.paramForm.controls['year_level_id'].setValue(null);
    this.paramForm.controls['school_program_id'].setValue(null);
    this.paramForm.controls['school_program_category_id'].setValue(null);
    this.paramForm.controls['school_program_activity_id'].setValue(null);
  }

  onChangeSchoolProgram(item: any) {
    this.paramForm.controls['school_program_id'].markAsTouched();
    this.paramForm.controls['school_program_id'].setValue(item ? item.school_program_id : null);

    this.paramForm.controls['school_program_category_id'].setValue(null);
    this.paramForm.controls['school_program_activity_id'].setValue(null);
  }

  onChangeSchoolProgramCategory(item: any) {
    this.paramForm.controls['school_program_category_id'].markAsTouched();
    this.paramForm.controls['school_program_category_id'].setValue(item ? item.school_program_category_id : null);

    this.paramForm.controls['school_program_activity_id'].setValue(null);
  }

  onChangeSchoolProgramActivity(item: any) {
    this.paramForm.controls['school_program_activity_id'].markAsTouched();
    this.paramForm.controls['school_program_activity_id'].setValue(item ? item.school_program_activity_id : null);
    if (item) {
      this.getActivityRegistrationPayment();
    }
  }

  clearData() {
    this.data = [];
    this.dataSource.data = [];
    this.totalItems = 0;
    this.page = 1;
    this.selectedIds.clear();
  }

  isSelected(registration_payment_id: number): boolean {
    return this.selectedIds.has(registration_payment_id);
  }

  toggleSelection(registration_payment_id: number) {
    if (this.selectedIds.has(registration_payment_id)) {
      this.selectedIds.delete(registration_payment_id);
    } else {
      this.selectedIds.add(registration_payment_id);
    }
  }

  isAllSelected(): boolean {
    return this.data.length > 0 && this.data.every(row => this.selectedIds.has(row.registration_payment_id));
  }

  toggleSelectAll() {
    if (this.isAllSelected()) {
      this.data.forEach(row => this.selectedIds.delete(row.registration_payment_id));
    } else {
      this.data.forEach(row => this.selectedIds.add(row.registration_payment_id));
    }
  }

  get hasSelection(): boolean {
    return this.selectedIds.size > 0;
  }

  onSearchChange() {
    this.page = 1;
    if (this.paramForm.controls['school_program_activity_id'].value) {
      this.getActivityRegistrationPayment();
    }
  }

  onFilterChange() {
    this.page = 1;
    if (this.paramForm.controls['school_program_activity_id'].value) {
      this.getActivityRegistrationPayment();
    }
  }

  onPageChanged(event: PageEvent) {
    this.page = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.getActivityRegistrationPayment();
  }

  onSortPaymentDate() {
    if (this.sortDirection === '' || this.sortDirection === 'desc') {
      this.sortDirection = 'asc';
    } else {
      this.sortDirection = 'desc';
    }
    this.applySorting();
  }

  applySorting() {
    if (!this.sortDirection) return;

    this.data.sort((a, b) => {
      const dateA = a.payment_date ? new Date(a.payment_date).getTime() : 0;
      const dateB = b.payment_date ? new Date(b.payment_date).getTime() : 0;
      return this.sortDirection === 'asc' ? dateA - dateB : dateB - dateA;
    });
    this.dataSource.data = [...this.data];
  }

  getActivityRegistrationPayment() {
    if (this.subscription.list) {
      this.subscription.list.unsubscribe();
    }
    this.loading.list = true;
    const params: any = {
      ...this.paramForm.value,
      show_student: true,
      page: this.page,
      page_size: this.pageSize,
      search: this.searchText,
      is_paid: this.filterPaid,
      is_manual_payment: this.isManualPayment,
      payment_generated: this.filterVaGenerated === false ? null : this.filterVaGenerated,
    };
    this.subscription.list = this.registService.getStudentRegistrationPayment(params).subscribe({
      next: (res) => {
        if (res.status) {
          this.data = res.data;
          this.dataSource.data = res.data;
          this.totalItems = res?.meta?.total ?? 0;
          if (this.sortDirection) {
            this.applySorting();
          }
          this.loading.list = false;
        } else {
          this.rpService.showAddError();
          this.loading.list = false;
        }
      },
      error: (res) => {
        this.rpService.showAddError();
        this.loading.list = false;
      }
    });
  }

  onApprovePayment(isApproving: boolean, id: number = null) {
    if (!this.hasSelection && !id) return;

    this.pendingApprove = isApproving;
    this.rejectNote = '';
    this.pendingIds = id ? [id] : Array.from(this.selectedIds);

    this.modalService.open(this.confirmModal, {
      ariaLabelledBy: 'confirm-modal-title',
      keyboard: false,
      backdrop: 'static',
      size: 'md'
    }).result.then(
      (confirmed) => {
        if (!confirmed) return;
        this.submitApprovePayment();
      },
      () => {}
    );
  }

  openPaymentLogsModal(registrationPaymentId: number) {
    this.selectedLogsPaymentId = registrationPaymentId;
    this.modalService.open(this.paymentLogsModal, {
      ariaLabelledBy: 'payment-logs-modal-title',
      size: 'xl',
      scrollable: true
    });
  }

  submitApprovePayment() {
    if (this.subscription.approve) {
      this.subscription.approve.unsubscribe();
    }

    this.loading.approve = true;
    const payload = {
      registration_payment_ids: this.pendingIds,
      is_approve: this.pendingApprove,
      reject_reason: this.pendingApprove ? null : this.rejectNote
    };

    this.subscription.approve = this.registService.onApprovePaymentBulk(payload).subscribe({
      next: (res) => {
        this.loading.approve = false;
        if (res.status) {
          this.rpService.showAddSuccess(`${this.pendingApprove ? 'Approved' : 'Rejected'} ${this.pendingIds.length} payment${this.pendingIds.length > 1 ? 's' : ''}`);
          this.selectedIds.clear();
          this.getActivityRegistrationPayment();
        } else {
          this.rpService.showAddError();
        }
      },
      error: () => {
        this.loading.approve = false;
        this.rpService.showAddError();
      }
    });
  }
}
